module.exports = __webpack_public_path__ + "img/OANDA_Onboarding_HeaderAnim_EN.545d1aa7.png";